import React from 'react';
import { useSelector } from 'react-redux';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { LanguageProvider } from 'context/LanguageContext';

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);

  return (
    <StyledEngineProvider injectFirst>
      <LanguageProvider>
        <ThemeProvider theme={themes(customization)}>
          <CssBaseline />
          <NavigationScroll>
            <div
              style={{
                background:
                  'linear-gradient(135deg, rgba(120, 228, 255, 0.28) 0%, rgba(255, 255, 255, 0.92) 24%, rgba(240, 231, 255, 0.76) 52%, rgba(255, 240, 215, 0.62) 76%, rgba(220, 255, 241, 0.72) 100%)',
                minHeight: '100vh',
                backgroundAttachment: 'fixed',
                fontFamily: '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
              }}
            >
              <Routes />
            </div>
          </NavigationScroll>
        </ThemeProvider>
      </LanguageProvider>
    </StyledEngineProvider>
  );
};

export default App;
